import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
var loadImage = function loadImage(onLoad, onError) {
  return function (src, isAnonymous) {
    var imageToLoad = new Image();
    if (isAnonymous) {
      imageToLoad.crossOrigin = 'Anonymous';
    }

    // pre-load the actual image
    imageToLoad.src = src;
    imageToLoad.onload = onLoad;
    imageToLoad.onerror = onError;
    return imageToLoad;
  };
};
var ImagePreloader = function ImagePreloader(props) {
  var src = props.src,
    isAnonymous = props.isAnonymous,
    onLoaded = props.onLoaded,
    onFailed = props.onFailed,
    children = props.children;
  var _useState = useState(ImagePreloader.STATUS_PENDING),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    image = _useState4[0],
    setImage = _useState4[1];
  var willUnmount = useRef();
  var handleImageLoaded = function handleImageLoaded() {
    if (willUnmount.current) {
      return;
    }
    setStatus(ImagePreloader.STATUS_LOADED);
    onLoaded(image);
  };
  var handleImageFailed = function handleImageFailed() {
    if (willUnmount.current) {
      return;
    }
    setStatus(ImagePreloader.STATUS_FAILED);
    onFailed(image);
  };
  var loadImageWithCallbacks = loadImage(handleImageLoaded, handleImageFailed);
  useEffect(function () {
    setImage(loadImageWithCallbacks(src, isAnonymous));
    return function () {
      willUnmount.current = true;
    };
  }, []);
  useEffect(function () {
    setStatus(ImagePreloader.STATUS_PENDING);
    setImage(loadImageWithCallbacks(src, isAnonymous));
  }, [src]);
  return children({
    status: status,
    image: image
  });
};
ImagePreloader.STATUS_PENDING = 'PENDING';
ImagePreloader.STATUS_LOADED = 'LOADED';
ImagePreloader.STATUS_FAILED = 'FAILED';
ImagePreloader.defaultProps = {
  onLoaded: function onLoaded() {},
  onFailed: function onFailed() {},
  isAnonymous: false
};
ImagePreloader.propTypes = {
  src: PropTypes.string.isRequired,
  onLoaded: PropTypes.func,
  onFailed: PropTypes.func,
  isAnonymous: PropTypes.bool
};
export default ImagePreloader;